/**
 *
 *  PasswordConfirmForm
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 02/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState, useEffect, useCallback } from "react";
import { useAppState } from "../../../state";
import { useSignUpState } from "../../../state/SignUpState";

// Components
import Button from "../../Button/Button";
import PasswordInput from "../../PasswordInput/PasswordInput";

// Icons
// import CheckNiceIcon from "../../../icons/CheckNiceIcon";
import ArrowRightIcon from "../../../icons/ArrowRightIcon";

export default function PasswordConfirmForm({ onNext }) {
  const { error } = useAppState();
  const { setUserPassword, hasAuthError } = useSignUpState();

  const [canSend, setCanSend] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [hasError, setHasError] = useState(false);

  const newPasswordRef = React.useRef();
  const newPasswordConfirmRef = React.useRef();

  useEffect(() => {
    if (newPasswordRef.current) {
      newPasswordRef.current.focus();
    }
  }, []);

  const handlePasswordChange = useCallback((e) => {
    const value = e.target.value;

    setHasError(false);
    setPassword(value);
  }, []);

  const handlePasswordConfirmChange = useCallback((e) => {
    const value = e.target.value;

    setHasError(false);
    setPasswordConfirm(value);
  }, []);

  useEffect(() => {
    if (password && passwordConfirm && password === passwordConfirm) {
      setCanSend(true);
    } else {
      setCanSend(false);
    }
  }, [password, passwordConfirm]);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      if (password.length < 5) {
        setHasError(true);

        return;
      }

      setUserPassword(password);

      onNext({ password });
    },
    [password, setUserPassword]
  );

  return (
    <>
      <div className="tbk-text-title-bold tbk-mb-1 tbk-text-grey-main">
        Create Your Password
      </div>
      <p className="tbk-text-main tbk-mb-4 tbk-text-grey-main">
        Please use uppercase and lowercase letters, numbers and symbols.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="">
          <div className="tbk-relative tbk-mb-3">
            <div className="tbk-text-small tbk-mb-0.5 tbk-text-black-grey">
              New password:
            </div>
            <PasswordInput
              ref={newPasswordRef}
              autoComplete="new-password"
              placeholder="Your password"
              minLength={5}
              maxLength={30}
              pattern="\s*(\S\s*){5,30}"
              password={password}
              onChange={handlePasswordChange}
              // onInput={handlePasswordChange}
            />
          </div>
          <div className="tbk-relative tbk-mb-3">
            <div className="tbk-text-small tbk-mb-0.5 tbk-text-black-grey">
              Confirm new password:
            </div>
            <PasswordInput
              ref={newPasswordConfirmRef}
              autoComplete="new-password"
              placeholder="Confirm password"
              minLength={5}
              maxLength={30}
              pattern="\s*(\S\s*){5,30}"
              password={passwordConfirm}
              onChange={handlePasswordConfirmChange}
              // onInput={handlePasswordConfirmChange}
            />
          </div>
        </div>
        {hasError || hasAuthError ? (
          <div className="tbk-text-main tbk--mt-2 tbk-mb-2 tbk-text-center tbk-text-coral">
            {error
              ? error.message
              : "Password should contain at least 5 characters"}
          </div>
        ) : null}
        <Button
          type="submit"
          className="tbk-mb-3 tbk-w-full"
          disabled={!canSend}
          endIcon={<ArrowRightIcon />}
        >
          Continue
        </Button>
      </form>
    </>
  );
}
